// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"79":"d5504b11","217":"00962675","360":"5b2a7d59","653":"5253403e","857":"3af933a5","956":"3af933a5"}[chunkId] + ".css";
};